import { http_get } from './BaseURLAxios';
import { FILTER_VALUE } from './urlConstants';

export const getFilterAPI = async () => {
    return await http_get(FILTER_VALUE).then((res: any) => {
        return res;
    });
};
